<template>
  <div>
    <h4>Billing Details</h4>
    <div v-if="nextInvoice">
      <p>Next Invoice Due: {{ nextInvoice.date | date }}</p>
      <p>
        Next Invoice Total:
        {{ (nextInvoice.amount / 100) | currency }}
      </p>
      <b-link :to="{ name: 'Billing' }" gtm-info="home-manage_plan">
        <i class="icon-pencil"></i>
        Manage Plan
      </b-link>
    </div>
    <p v-else>No billing information to show.</p>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("billing", ["nextInvoice"])
  }
};
</script>
